import styled from 'styled-components';
import { Navigation } from '../common/Navigation/Navigation';

interface Props {
  children: React.ReactElement;
}

const Root = styled('div')`
  position: relative;
  min-height: 100vh;
  z-index: 1;
  overflow: hidden;
  ::before {
    content: '';
    position: absolute;
    left: 35%;
    height: 100%;
    width: 100%;
    right: 0;
    top: 1.41%;
    bottom: 4.46%;
    z-index: -1;

    background: radial-gradient(
      100.01% 50% at 0.01% 50%,
      rgba(224, 47, 41, 0.5) 0%,
      rgba(39, 40, 58, 0) 100%
    );
    transform: matrix(-1, 0, 0, 1, 0, 0);
  }

  @media only screen and (max-width: 600px) {
  }
`;
export const PublicLayout = ({ children }: Props) => {
  return (
    <Root>
      <div className='bg' />
      <Navigation />
      {children}
    </Root>
  );
};
